export interface UserInfo {
  id?: number;
  company: { type: string; name: string; id?: number };
  is_company_admin?: boolean; // Indicates if the user is a data admin (the other roles are 'admin' and 'viewer)
  contact?: {
    email?: string;
    first_name?: string;
    last_name?: string;
  };
}

export interface UserState {
  userInfo: UserInfo | null;
  canEditPlantationTableColumns: boolean;
  /**
   * True once the user-info request has settled, succeeded or failed.
   * `userInfo: null` alone cannot tell those two apart from "not fetched yet".
   */
  userInfoLoaded: boolean;
}

export const INITIAL_USER_STATE: UserState = {
  userInfo: null,
  canEditPlantationTableColumns: false,
  userInfoLoaded: false
};
